export const appointmentCancellation = {
  state: { appointmentCancellation: [] },
  reducers: {
    fetchStart: (state, { appointmentCancellationScreen }) => ({
      ...state,
      appointmentCancellation: appointmentCancellationScreen,
    }),
  },
};
